import {
  MEASUREMENT_CALCULATIONS,
  TIME_BOUNDS,
  QUALITY_DOMAINS,
  PERFORMANCE_METRIC_STATUSES
} from '@shared/constants/checkpoint-performance-report-metric-enums.js';
import { PERFORMANCE_METRIC_INPUT_TYPES } from '../performanceMetric/PerformanceMetricInputCard.js';

export const PerformanceMetricValidator = {
  validateLowerUpperLimit({ lowerLimit, upperLimit }) {
    if (lowerLimit === '-' || upperLimit === '-') {
      return { hasError: true, errorMessage: '' };
    }

    const parsedLowerLimit = lowerLimit ? parseFloat(lowerLimit) : null;
    const parsedUpperLimit = upperLimit ? parseFloat(upperLimit) : null;

    if (parsedUpperLimit === null && parsedLowerLimit === null) {
      return { hasError: true, errorMessage: '' };
    }

    if (
      parsedLowerLimit !== null &&
      parsedUpperLimit !== null &&
      parsedLowerLimit > parsedUpperLimit
    ) {
      return { hasError: true, errorMessage: 'Upper limit cannot be less than the lower limit.' };
    }

    return { hasError: false, errorMessage: '' };
  },

  validatePerformanceMetric(
    formData,
    validationErrors,
    fields,
    pageSettings,
    getNewErrorObject,
    getDefaultErrorObject
  ) {
    let errors = { ...validationErrors };

    fields.forEach(key => {
      const value = formData[key];
      const field = pageSettings.metricProperties.find(x => x.field === key);
      if (!value) {
        const errorMessage =
          field.type === PERFORMANCE_METRIC_INPUT_TYPES.text
            ? `Provide alphanumeric input under ${field.maxLength} characters.`
            : '';
        errors[key] = getNewErrorObject(errors[key], {
          hasError: true,
          errorMessage: errorMessage
        });
      }
    });

    if (!formData.measurementCalculation) {
      errors.numerator = getDefaultErrorObject(errors.numerator);
      errors.denominator = getDefaultErrorObject(errors.denominator);
      errors.measurementUnit = getDefaultErrorObject(errors.measurementUnit);
    } else if (formData.measurementCalculation === MEASUREMENT_CALCULATIONS.TotalCount.Id) {
      errors.numerator = getDefaultErrorObject(errors.numerator);
      errors.denominator = getDefaultErrorObject(errors.denominator);
    } else {
      errors.measurementUnit = getDefaultErrorObject(errors.measurementUnit);
    }

    if (formData.qualityDomain !== QUALITY_DOMAINS.NA.Id) {
      errors.customQualityDomainDefinition = getDefaultErrorObject(
        errors.customQualityDomainDefinition
      );
    }

    if (formData.timeBounds === TIME_BOUNDS.AllTime.Id) {
      errors.timeFrame = getDefaultErrorObject(errors.timeFrame);
    }

    const limitErrors = this.validateLowerUpperLimit(formData);
    errors.lowerLimit = getNewErrorObject(errors.lowerLimit, limitErrors);
    errors.upperLimit = getNewErrorObject(errors.upperLimit, limitErrors);

    if (formData.status !== PERFORMANCE_METRIC_STATUSES.Update.Id) {
      errors.lowerLimit = getDefaultErrorObject(errors.lowerLimit);
      errors.upperLimit = getDefaultErrorObject(errors.upperLimit);
      errors.actual = getDefaultErrorObject(errors.actual);
    }

    if (formData.status === PERFORMANCE_METRIC_STATUSES.NA.Id) {
      errors.notes = getDefaultErrorObject(errors.notes);
    }

    return errors;
  }
};
